module.exports = __webpack_public_path__ + "img/empty.3d07ffc8.png";